import { Modal, Radio, Space } from 'antd';
import { useEffect, useState } from 'react';

const SortModal = ({ sort_modal, set_sort_modal, active_sort, set_active_sort, sort_list }) => {
  const [pre_active, set_pre_active] = useState(active_sort);

  const sort_pre_handel = (e) => {
    set_pre_active(e.target.value);
  };

  useEffect(() => {
    if (sort_modal) {
      set_pre_active(active_sort);
    }
    // eslint-disable-next-line
  }, [sort_modal]);

  const submit_click = () => {
    set_active_sort(pre_active);
    set_sort_modal(false);
  };

  return (
    <Modal
      className="sort-modal"
      closeIcon={<div />}
      footer={null}
      onCancel={() => set_sort_modal(false)}
      visible={sort_modal}>
      <div className="sort-modal-container">
        <Radio.Group onChange={sort_pre_handel} value={pre_active}>
          <Space direction="vertical">
            {sort_list.map((sort_item) => (
              <Radio key={sort_item.key} value={sort_item.key}>
                {sort_item.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        <button className="sort-modal-button" onClick={submit_click} type="button">
          اعمال
        </button>
      </div>
    </Modal>
  );
};

export default SortModal;
